import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { User } from '@dispo-shared/open-api/models/user';
import { TagComponent } from '../tag/tag.component';
import { TagGroupComponent } from '../tag-group/tag-group.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'xyz-shared-driver-roles',
    imports: [TagComponent, TagGroupComponent, TranslateModule],
    templateUrl: './driver-roles.component.html',
    styleUrls: ['./driver-roles.component.scss']
})
export class DriverRolesComponent implements OnChanges {
  @Input()
  public users: User[] | undefined = [];

  @Input()
  public clusterDriverRoles = true;

  public skillObj: { [key: string]: User[] } = {};
  public driverRolesObj: { [key: string]: User[] } = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['users'] && changes['users'].currentValue && this.users) {
      this.setSkills(this.users);
    }
  }

  private setSkills(users: User[]): void {
    this.skillObj = {};
    this.driverRolesObj = {};
    this.skillObj = users.reduce(
      (acc, user) => {
        if (!user.skills || user.skills.length === 0) {
          this.pushOrSet(acc, 'NO_ROLE', user);
          this.pushOrSet(this.driverRolesObj, 'NO_ROLE', user);
        } else {
          let foundRole = false;
          user.skills.forEach((skill) => {
            if (!skill.skill_type) return;
            this.pushOrSet(acc, skill.skill_type, user);

            if (skill.skill_type === 'DRIVER_ROLE') {
              if (!skill.skill) return;
              this.pushOrSet(this.driverRolesObj, skill.skill, user);
              foundRole = true;
            }
          });
          if (!foundRole) {
            this.pushOrSet(acc, 'NO_ROLE', user);
            this.pushOrSet(this.driverRolesObj, 'NO_ROLE', user);
          }
        }
        return acc;
      },
      {} as { [key: string]: User[] }
    );
  }

  private pushOrSet(obj: { [x: string]: unknown[] | User[]; }, key: string, value: User): void {
    if (obj[key]) {
      obj[key].push(value);
    } else {
      obj[key] = [value];
    }
  }
}
